import { visitor } from '@rhitics/core'
import { getAppConfig } from '@rhitics/rhitics/config'
import { SigninGuard } from '@rhitics/core/libs/SigninGuard'
import { toRhitics } from '@rhitics/utils/links'

export async function bootApp<T>(createApp: Function, appName: string, el: string | null = null): Promise<T | void> {

  /**
   * We would like to know env as beginning.
   */
  const isProduction = process.env.NODE_ENV === 'production'

  console.log(`程式啟動中 [Domain: ${appName}] [環境: ${isProduction ? 'prod' : 'dev'}]...`)

  /**
   * Setup application api domain.
   * This should setup before everything.
   * By default only production env apply https://api.rhitics.com
   */
  const apiDomain = process.env.VUE_APP_API_DOMAIN
  visitor.setOptions({ domain: apiDomain })

  /**
   * Create app instance.
   */
  const app = await createApp()

  /**
   * Try to get token from Auth(cookie).
   */
  const token = app.$auth.getTokenFromCookie()

  /*
   * 預設所有的 route 都是 authorize，即使是沒有使用 vue-router
   * 只有少數幾個將 meta.authorize 設定為 false 的 route 不用登入即可訪問
   * 如： /login、/register, /reset_password
   */
  let shouldAuthorize: boolean = isProduction
  if (app.$route && app.$route.meta.authorize !== undefined) {
    shouldAuthorize = app.$route.meta.authorize
  }

  /**
   * if is production mode and env doesn't have token cookie
   * redirect user to login page. and remember current url by default
   * after login sucess, remembered url can use to as redirect url.
   */
  if (!token && shouldAuthorize) {
    return SigninGuard.redirectToLoginPage()
  }

  if (token) {
    try {
      const user = await app.$auth.fetchUserData()
      if (user.resignedAt) {
        alert(`沒有權限可以進入 ${appName}, 導回登入`)
        app.$auth.setToken(null)
        app.$auth.setUser(null)
        toRhitics('login')
      }

      app.$auth.setUser(user)
      app.$auth.setToken(token)

      const config = getAppConfig(appName)

      /** check visit policy  */
      if (config) {
        const { policy } = config
        const canVisit = !policy || app.$auth.can(policy)
        console.log(`是否有權限可以進入: ${canVisit}`)

        if (!canVisit) {
          // alert(`沒有權限可以進入 ${appName}, 導回入口頁面`)
          // toRhitics('home')
        }
      }

      /** Set locale according to user's setting  */
      if (app.$i18n) {
        app.$i18n.locale = user.lang || 'zh-TW'
        localStorage.setItem('locale_preference', app.$i18n.locale)
        console.log(`語言: ${app.$i18n.locale}`)
      }
    } catch (error) {
      console.error(error)
      app.$auth.forget()
      return SigninGuard.redirectToLoginPage()
    }

    if (app.$auth.user && app.$vuetify) {
      app.$vuetify.theme.dark = app.$auth?.user.theme === 'dark'
      localStorage.setItem('circadian_theme', app.$auth.user.theme)
    }
  }

  if (el) app.$mount(el)

  console.log(`掛載完成，歡迎使用`)

  return app
}
